import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { IFloatingFilterAngularComp } from 'ag-grid-angular';
import { IFloatingFilterParams, ISimpleFilter } from 'ag-grid-community';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import * as CONSTANT from 'src/app/shared/constants/constant-list';
import { selectLRCTypes } from 'src/app/shared/stores/slices/compliance';

export interface CustomParams {
  suppressFilterButton: boolean;
  filter: string;
  onSearchEvent: (event: any) => void;
}

@Component({
  selector: 'app-lrc-type-renderer',
  templateUrl: './lrc-type-renderer.component.html',
  styleUrls: ['./lrc-type-renderer.component.scss'],
})
export class LrcTypeRendererComponent implements IFloatingFilterAngularComp {
  @Output() onFilterSearchText: EventEmitter<any> = new EventEmitter<any>();

  filterSearchText = new Subject<any>();
  filterText: string | null = null;

  params!: IFloatingFilterParams<ISimpleFilter> & CustomParams;
  IFloatingParams: IFloatingFilterParams | any;

  LRC_TYPES: any = CONSTANT.LRC_TYPES;

  filterOptions: any[] = [];
  currentValue: any;
  value: any;

  constructor(private store: Store) {}

  agInit(params: IFloatingFilterParams<ISimpleFilter> & CustomParams) {
    this.filterOptions = [
      {
        value: this.LRC_TYPES.CASH_IN,
        name: 'CASH IN',
      },
      {
        value: this.LRC_TYPES.CASH_OUT,
        name: 'CASH OUT',
      },
      {
        value: this.LRC_TYPES.PAYMENT,
        name: 'PAYMENT',
      },
      {
        value: this.LRC_TYPES.TRANSFER,
        name: 'TRANSFER',
      },
    ];

    this.store.select(selectLRCTypes).subscribe({
      next: (resp) => {},
    });

    this.filterText = null;
    this.params = params;

    this.filterSearchText
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe({
        next: (event: any) => {
          this.params?.onSearchEvent({
            value: event?.target?.value,
            filter: params?.filter,
          });
        },
      });
  }

  onParentModelChanged(parentModel: any) {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
      this.filterOptions = [];
    } else {
      this.currentValue = parentModel.filter;
    }
  }
}
